import { Typography, Box } from "@mui/material" 
import FormDescription from "../../../../inputFormComponents/FormDescription"
import image from './../../../../resources/InvoiceType.png'
import { useGetList } from "react-admin"

const DescriptionInvoiceType = () => {

  const { data: numberRanges, isLoading: numberRangesLoading} = useGetList(
    'numberRanges', 
    {sort: {field: "name", order: "ASC"}, pagination: {page: 1, perPage: 50}}
  )

  if(numberRangesLoading) return null

  return (
    <FormDescription 
      paragraphs={[
        <Box key={1}>
          <Typography variant="body1">Rechnungsart:</Typography>
          <Typography variant="body2">Über die Rechnungsart steuerst du den Steuerschlüssel und die Hinweistexte für bestimmte Geschäftsvorfälle. Gleichzeitig werden auch die richtigen Buchungskonten für eine spätere Verbuchung in deiner Buchhaltung hinterlegt.</Typography>
        </Box>,
        <Box key={2}>
          <Typography variant="body1">Zahlungsfrist:</Typography>
          <Typography variant="body2">Die Zahlungsfrist wird automatisch auf deiner Rechnung übernommen. Wenn du keine Zahlungsfrist auf deiner Rechnung angeben möchtest, kannst du die Zahlungsfrist einfach löschen.</Typography>
        </Box>,
        <Box key={3} display={numberRanges?.length === 1 ? 'none' : 'block'}>
          <Typography variant="body1">Rechnungsnummer:</Typography>
          <Typography variant="body2">Die Standard Rechnungsnummer wird automatisch auf deine Rechnung übernommen.</Typography>
        </Box>
      ]}
      image={image}
    />
  )
}

export default DescriptionInvoiceType